import { createBaseApi } from "../baseApi";
import { API_CONFIG } from "config/api.config";
import PayloadModel from "model/_payload/payload.schema";
import { CommissionsModel } from "model/commissions/commissions.schema";

export const commissionsApi = createBaseApi("commission", "/commissions").injectEndpoints({
  overrideExisting: false,
  endpoints: (builder) => ({
    // Get Commissions
    getCommissions: builder.query({
      query: (value) => {
        const payload = PayloadModel.modelToJson(value);
        return {
          url: "",
          method: "GET",
          params: payload,
        };
      },
      providesTags: ["Commissions"],
      transformResponse: (response) => {
        return CommissionsModel.jsonToModel(response);
      },
    }),

    // Delete Commissions
    deleteCommissions: builder.mutation({
      query: (commissionIds) => {
        return {
          url: API_CONFIG.USE_MOCK ? "/commissions/delete-commissions.json" : "/commissions/delete",
          method: "DELETE",
          body: { commissionIds },
        };
      },
      transformResponse: (response) => {
        return response;
      },
    }),

    // Update Commission
    updateCommission: builder.mutation({
      query: ({ id, commissionRate }) => {
        return {
          url: `/${id}`,
          method: "PUT",
          body: { commissionRate },
        };
      },
      invalidatesTags: ["Commissions"],
      transformResponse: (response) => {
        return response;
      },
    }),
  }),
});

export const { useGetCommissionsQuery, useDeleteCommissionsMutation, useUpdateCommissionMutation } = commissionsApi;
